/* LodyFair verlanglijst.

   Opslag in localStorage, dus zonder account en zonder externe app. We bewaren
   alleen de producthandle; de gegevens op de verlanglijstpagina halen we vers
   op, zodat prijzen en voorraad daar altijd kloppen.

   Werkt op productkaarten, productpagina's, de teller in de header en de
   pagina /pages/wishlist. */
(function () {
  var SLEUTEL = 'lfVerlanglijst';

  function lees() {
    try {
      var ruw = window.localStorage.getItem(SLEUTEL);
      var lijst = ruw ? JSON.parse(ruw) : [];
      return Array.isArray(lijst) ? lijst : [];
    } catch (e) {
      return [];
    }
  }

  function schrijf(lijst) {
    try {
      window.localStorage.setItem(SLEUTEL, JSON.stringify(lijst));
    } catch (e) { /* privémodus: dan alleen deze sessie */ }
    werkBij();
    document.dispatchEvent(new CustomEvent('lf:verlanglijst', { detail: { aantal: lijst.length } }));
  }

  function bevat(handle) {
    return lees().indexOf(handle) !== -1;
  }

  function wissel(handle) {
    var lijst = lees();
    var i = lijst.indexOf(handle);
    if (i === -1) lijst.push(handle);
    else lijst.splice(i, 1);
    schrijf(lijst);
    return i === -1;
  }

  function verwijder(handle) {
    var lijst = lees();
    var i = lijst.indexOf(handle);
    if (i !== -1) { lijst.splice(i, 1); schrijf(lijst); }
  }

  /* ---------- doorgeven aan Klaviyo ----------

     De verlanglijst leeft alleen in de browser van de bezoeker; zonder dit
     signaal weet niemand welke producten het meest gewild zijn. Elk hartje
     stuurt daarom een gebeurtenis naar Klaviyo (dat script staat er toch al).
     Daarmee kun je daar segmenten en flows bouwen: prijsdaling-mails,
     voorraad-mails, een ranglijst van gewilde producten.

     Klaviyo koppelt de gebeurtenis aan het profiel zodra het de bezoeker kent
     (na een aanmelding of aankoop); tot die tijd bewaart het hem anoniem bij
     de cookie. Faalt er iets, dan faalt het stil — de verlanglijst zelf mag
     hier nooit last van hebben. */
  function meldKlaviyo(handle, toegevoegd) {
    try {
      var naam = toegevoegd ? 'Toegevoegd aan verlanglijst' : 'Verwijderd van verlanglijst';
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !window.klaviyo) return;
          window.klaviyo.push(['track', naam, {
            ProductNaam: p.title,
            ProductHandle: p.handle,
            Prijs: (p.price / 100),
            URL: location.origin + '/products/' + p.handle,
            Afbeelding: p.featured_image || null
          }]);
        })
        .catch(function () {});
    } catch (e) { /* stil */ }
  }

  /* ---------- weergave ---------- */

  function werkBij() {
    var lijst = lees();

    // hartjes op kaarten en productpagina's
    var harten = document.querySelectorAll('[data-lf-hart]');
    for (var i = 0; i < harten.length; i++) {
      var aan = lijst.indexOf(harten[i].getAttribute('data-lf-hart')) !== -1;
      harten[i].classList.toggle('is-aan', aan);
      harten[i].setAttribute('aria-pressed', aan ? 'true' : 'false');
    }

    // teller in de header
    var tellers = document.querySelectorAll('[data-lf-verlanglijst-teller]');
    for (var j = 0; j < tellers.length; j++) {
      tellers[j].textContent = lijst.length;
      tellers[j].hidden = lijst.length === 0;
    }
  }

  /* ---------- de pagina ---------- */

  /* Bedragen komen uit het thema zelf, niet uit een vast valutateken. Het
     formaat staat in theme.settings.moneyFormat en wordt in layout/theme.liquid
     door Liquid neergezet, zodat dit hetzelfde toont als de productpagina en
     blijft kloppen als de valuta of Markets verandert.

     Zonder theme.js valt hij terug op het kale bedrag: geen bedrag is beter
     dan een bedrag met het verkeerde teken ervoor. */
  function geld(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function tekenPagina() {
    var houder = document.querySelector('[data-lf-verlanglijst-lijst]');
    if (!houder) return;

    var leeg = document.querySelector('[data-lf-verlanglijst-leeg]');
    var lijst = lees();

    if (!lijst.length) {
      houder.innerHTML = '';
      if (leeg) leeg.hidden = false;
      return;
    }
    if (leeg) leeg.hidden = true;

    houder.setAttribute('aria-busy', 'true');

    Promise.all(lijst.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (producten) {
      houder.removeAttribute('aria-busy');
      var html = '';
      var verdwenen = [];

      producten.forEach(function (p, index) {
        if (!p) { verdwenen.push(lijst[index]); return; }
        var foto = p.featured_image ? p.featured_image.replace(/(\.[a-z]{3,4})(\?|$)/, '_400x$1$2') : '';
        var prijs = p.price_varies
          ? (houder.dataset.vanaf || 'From') + ' ' + geld(p.price_min)
          : geld(p.price);
        var oud = (p.compare_at_price && p.compare_at_price > p.price)
          ? '<span class="lf-vl__prijs-oud">' + geld(p.compare_at_price) + '</span>' : '';

        html += '<div class="lf-vl__kaart">' +
          '<button type="button" class="lf-vl__weg" data-lf-verlanglijst-weg="' + p.handle + '" aria-label="' + (houder.dataset.verwijderen || 'Remove') + '">' +
          '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13"/></svg>' +
          '</button>' +
          '<a href="/products/' + p.handle + '" class="lf-vl__foto-link">' +
          (foto ? '<img src="' + foto + '" alt="" loading="lazy">' : '<span class="lf-vl__geenfoto"></span>') +
          '</a>' +
          '<div class="lf-vl__info">' +
          '<a href="/products/' + p.handle + '" class="lf-vl__titel">' + p.title + '</a>' +
          '<p class="lf-vl__prijs">' + prijs + oud + '</p>' +
          (p.available ? '' : '<p class="lf-vl__uitverkocht">' + (houder.dataset.uitverkocht || 'Sold out') + '</p>') +
          '</div>' +
          '</div>';
      });

      // producten die niet meer bestaan stilletjes opruimen
      if (verdwenen.length) {
        var schoon = lees().filter(function (h) { return verdwenen.indexOf(h) === -1; });
        schrijf(schoon);
      }

      houder.innerHTML = html;
      if (!html && leeg) leeg.hidden = false;
    });
  }

  /* ---------- gebeurtenissen ---------- */

  document.addEventListener('click', function (e) {
    var hart = e.target.closest('[data-lf-hart]');
    if (hart) {
      e.preventDefault();
      e.stopPropagation();
      var handle = hart.getAttribute('data-lf-hart');
      var toegevoegd = wissel(handle);
      meldKlaviyo(handle, toegevoegd);
      return;
    }

    var weg = e.target.closest('[data-lf-verlanglijst-weg]');
    if (weg) {
      e.preventDefault();
      verwijder(weg.getAttribute('data-lf-verlanglijst-weg'));
      tekenPagina();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var hart = e.target.closest && e.target.closest('[data-lf-hart]');
    if (hart) {
      e.preventDefault();
      var handle = hart.getAttribute('data-lf-hart');
      meldKlaviyo(handle, wissel(handle));
    }
  }, true);

  // andere tabbladen van dezelfde bezoeker meenemen
  window.addEventListener('storage', function (e) {
    if (e.key === SLEUTEL) { werkBij(); tekenPagina(); }
  });

  werkBij();
  tekenPagina();

  window.lfVerlanglijst = {
    lees: lees,
    bevat: bevat,
    wissel: wissel,
    verwijder: verwijder,
    _teken: tekenPagina,
    _werkBij: werkBij
  };
})();
